import React from "react";

/**
 * A fixed film grain plate. Generated with feTurbulence so it costs one
 * inline SVG rather than a texture download, and it is what stops large
 * flat fields of colour from reading as "flat vector gradient".
 */
export default function Grain() {
  return (
    <svg className="grain" aria-hidden="true" focusable="false">
      <filter id="ab-grain">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.82"
          numOctaves="3"
          stitchTiles="stitch"
        />
        <feColorMatrix type="saturate" values="0" />
      </filter>
      <rect width="100%" height="100%" filter="url(#ab-grain)" />
    </svg>
  );
}
